let IconUrls = {
    SOCIAL: "icons/social.svg",
    "SOCIAL + NEWS": "icons/social.svg",
    NEWS: "icons/news.svg",
    INSIGHTS: "icons/insights.svg",
    CONVERSATIONS: "icons/social.svg",
    VIRALITY: "icons/virality.svg",
    Insights: "icons/insights.svg",
    "KEY OPINION LEADERS": "icons/key-opinion.svg",
    SCANNER: "icons/scanner.svg",
    TRENDS: "icons/trends.svg",
    THEMES: "icons/themes.svg",
    COLLECTIONS: "icons/insights.svg",
    SPARKS: "icons/sparks.svg",
    sidebar_dropdown: "icons/sidebar_dropdown.svg",
    "three-dots-loader": "icons/three-dots-loader.svg",
    "positive-sentiment": "icons/positive-sentiment.svg",
    "negative-sentiment": "icons/negative-sentiment.svg",
    "neutral-sentiment": "icons/neutral-sentiment.svg",
    tempoFlag: "icons/flag-grey.svg",
    redTempoFlag: "icons/flag-red.svg",
    "post-close": "icons/post-close.svg",
    ideaSpark: "icons/idea-icon.svg",

    // post hovers
    "viewmore-tooltip": "icons/viewmore-tooltip.svg",
    spam: "icons/spam-w.svg",
    "spam-grey": "icons/spam-b.svg",
    "add-collection": "icons/add-collection-tooltip.svg",
    "add-spark": "icons/creata-spark-tooltip.svg",
    "email-post": "icons/email-this-post-tooltip.svg",
    "add-collection-grey": "icons/add-collection-grey.svg",
    "add-spark-grey": "icons/create-spark-grey.svg",
    "email-post-grey": "icons/email-grey.svg",
    tag: "icons/tag.svg",
    "update-assigned": "icons/assignedStatus.svg",
    assigned: "icons/how_to_reg.svg",
    "set-cover-pic": "icons/setCoverPhoto.svg",
    email: "icons/email.svg",
    drafts: "icons/drafts.svg",
    archive: "icons/archive.svg",
};

export { IconUrls };
